const toggleMenu = (event) => {
   const headerBurgerButton = event.target;
   const activeBurgerButtonClass = 'burger-button-open';
   const headerElement = document.querySelector('[data-header]');
   const headerElementClass = 'header-menu-open';
   const headerPinButton = document.querySelector('[data-header-pin-button]');
   const headerPinButtonClass = 'header-pin-button-dark';
   const mobileMenu = document.querySelector('[data-mobile-menu]');
   const mobileMenuClass = 'mobile-menu-open';
   const activeBodyClass = 'overflow-y-hidden';

   headerBurgerButton.classList.toggle(activeBurgerButtonClass);
   headerElement.classList.toggle(headerElementClass);
   headerPinButton.classList.toggle(headerPinButtonClass);
   mobileMenu.classList.toggle(mobileMenuClass);
   document.body.classList.toggle(activeBodyClass);
};

export default toggleMenu;